import { render, staticRenderFns } from "./PkHomepage.vue?vue&type=template&id=7d731ff1&scoped=true&"
import script from "./PkHomepage.vue?vue&type=script&lang=js&"
export * from "./PkHomepage.vue?vue&type=script&lang=js&"
import style0 from "./PkHomepage.vue?vue&type=style&index=0&id=7d731ff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d731ff1",
  null
  
)

/* custom blocks */
import block0 from "./PkHomepage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports